<template>
  <footer id="fh5co-footer">
    <div class="row">
      <div class="col-md-6 col-md-offset-3 text-center">
        <small>
          &copy; 2016 Personal Free HTML5 Template. All Rights Reserved.
          <span class="fh5co-author">
            Designed by
            <a href="http://freehtml5.co" target="_blank">FreeHTML5.co</a>
            Demo Images:
            <a href="http://unsplash.com/" target="_blank">Unsplash</a></span
          >
        </small>
      </div>
    </div>
  </footer>
</template>
<style scoped>
#fh5co-footer {
  opacity: 0.5;
}
</style>